import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => (
  <div className="notfound">
    <div>
      <h1>404</h1>
      <p style={{ color: 'var(--muted)' }}>Bu rota yok.</p>
      <div className="hero-actions" style={{ justifyContent: 'center' }}>
        <Link to="/" className="btn btn-fill">Ana sayfa</Link>
        <Link to="/projects" className="btn btn-ghost">İşler</Link>
      </div>
    </div>
  </div>
);

export default NotFound;
